var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeprecatedMouseLeftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 20C5.06667 20 3.41667 19.3167 2.05 17.95C0.683333 16.5833 0 14.9333 0 13V7C0 5.06667 0.683333 3.41667 2.05 2.05C3.41667 0.683333 5.06667 0 7 0C8.93333 0 10.5833 0.683333 11.95 2.05C13.3167 3.41667 14 5.06667 14 7V13C14 14.9333 13.3167 16.5833 11.95 17.95C10.5833 19.3167 8.93333 20 7 20ZM8 7H12C12 5.8 11.6208 4.74167 10.8625 3.825C10.1042 2.90833 9.15 2.33333 8 2.1V7ZM7 18C8.38333 18 9.5625 17.5125 10.5375 16.5375C11.5125 15.5625 12 14.3833 12 13V9H2V13C2 14.3833 2.4875 15.5625 3.4625 16.5375C4.4375 17.5125 5.61667 18 7 18Z",
    fill: "#0D0A0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeprecatedMouseLeftIcon);
export default __webpack_public_path__ + "static/media/DeprecatedMouseLeftIcon.33c853438ffc8569cd9c415002905336.svg";
export { ForwardRef as ReactComponent };